module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-34.7be24811.png";